// extracted by mini-css-extract-plugin
export var deleteModal = "_sg-0";